
import { defineComponent, PropType } from 'vue';
import { useI18n } from 'vue-i18n';
import Dropdown from 'primevue/dropdown';

export default defineComponent({
  name: 'ReuseCouponSelector',

  components: {
    Dropdown,
  },

  props: {
    modelValue: {
      type: Number,
      required: true,
    },
    options: {
      type: Array as PropType<Array<{ label: string; value: number }>>,
      required: true,
    },
  },

  emits: ['update:modelValue'],

  setup() {
    const { t } = useI18n();
    return { t };
  },
});
